(function () {
    'use strict';

    var tool = document.getElementById('detector-tool');
    if (!tool) return;

    /* Clicking a sentence opens a popover with its probability and what its
       color means. False drops the pointer, the ring, the popover and the
       "tap a sentence" hint in the legend, and leaves the code in place. */
    var SENTENCE_DETAILS = true;

    /* Runtime strings resolve through the page's __() map (page.blade.php)
       when it carries the matching content.* key, so localized pages show a
       localized report; the English literal stays as the fallback. Same
       pattern as styleLabel in data_q.js. */
    function t(key, fallback) {
        if (typeof __ !== 'function') return fallback;
        var value = __('content.' + key);
        return value === 'content.' + key ? fallback : value;
    }

    // Match the server's integer labels: the page language's grouping from
    // partial/number-format.blade.php, independent of the browser locale.
    function formatCount(value) {
        return window.formatNumber ? window.formatNumber(value) : String(value);
    }

    var form = document.getElementById('detectorForm');
    var input = document.getElementById('detectorInput');
    var output = document.getElementById('detectorOutput');
    var submit = document.getElementById('detectorSubmit');
    var clear = document.getElementById('detectorClear');
    var counter = document.getElementById('detectorWordCount');
    var sentenceCounter = document.getElementById('detectorSentenceCount');
    var copy = document.getElementById('detectorCopy');
    var copyText = document.getElementById('detectorCopyText');
    var resultNote = document.getElementById('detectorResultNote');
    var humanizeCta = document.getElementById('detectorHumanizeCta');
    // after a check the scored text takes the place of the textarea (sample v2)
    var inputRender = document.getElementById('detectorInputRender');
    // legend + disclaimer: a sibling of the scroll box, not a child of it
    var inputFoot = document.getElementById('detectorInputFoot');
    var inputError = document.getElementById('detectorInputError');
    var csrf = document.querySelector('meta[name="csrf-token"]');
    var minWords = Math.max(1, Number(tool.dataset.minWords || 30));
    var maxWords = Math.max(minWords, Number(tool.dataset.maxWords || 3000));
    var pollTimer = null;
    var loaderTimer = null;
    var activeJobId = null;
    var currentReport = null;
    var submittedText = '';
    var busy = false;
    var requestVersion = 0;

    /* 90 words on purpose: long enough to clear the detector's 80-word
       minimum, short enough that the humanizer handoff runs it without
       retries, and AI-flavoured enough to score as AI on a first check. */
    /* The demo text, in the language the page is served in: the detector
       reads Spanish and Portuguese, so a visitor on /es or /pt-br who presses
       Try a sample should be handed something it can actually score for them.
       Same text as the humanizer's sample (data_q.js), in each language; keyed
       like data_q.js, by the full page language first. */
    var samples = {
        en: 'In today’s rapidly evolving digital landscape, artificial intelligence has become an indispensable tool for businesses of all sizes. It is important to note that companies leveraging these technologies often experience significant improvements in operational efficiency. Moreover, the implementation of automated solutions allows organizations to streamline their workflows and reduce unnecessary costs. However, it is crucial to remember that technology alone cannot guarantee success. Ultimately, businesses must foster a culture of innovation, ensuring that employees are properly trained and motivated to truly embrace the transformative potential of these powerful digital tools.',
        es: 'En el panorama digital actual, que evoluciona con gran rapidez, la inteligencia artificial se ha convertido en una herramienta indispensable para las empresas de todos los tamaños. Es importante señalar que las compañías que aprovechan estas tecnologías suelen experimentar mejoras significativas en su eficiencia operativa. Además, la implementación de soluciones automatizadas permite a las organizaciones optimizar sus flujos de trabajo y reducir costes innecesarios. Sin embargo, resulta fundamental recordar que la tecnología por sí sola no garantiza el éxito. En última instancia, las empresas deben fomentar una cultura de innovación, asegurando que los empleados estén debidamente formados y motivados para aprovechar todo el potencial transformador de estas poderosas herramientas digitales.',
        'pt-br': 'No cenário digital atual, que evolui rapidamente, a inteligência artificial tornou-se uma ferramenta indispensável para empresas de todos os portes. É importante ressaltar que as empresas que aproveitam essas tecnologias costumam obter melhorias significativas em sua eficiência operacional. Além disso, a implementação de soluções automatizadas permite que as organizações otimizem seus fluxos de trabalho e reduzam custos desnecessários. No entanto, é fundamental lembrar que a tecnologia, por si só, não garante o sucesso. Em última análise, as empresas devem fomentar uma cultura de inovação, garantindo que os colaboradores estejam devidamente capacitados e motivados para aproveitar todo o potencial transformador dessas poderosas ferramentas digitais.'
    };
    var pageLanguage = (document.documentElement.lang || 'en').toLowerCase();
    var sample = samples[pageLanguage] || samples[pageLanguage.slice(0, 2)] || samples.en;

    /* Fingerprinting probes canvas, audio and fonts — a heavy scripting burst
       that used to fire as this deferred script evaluated, inside the
       blocking-time window PageSpeed measures. The id only travels with job
       submits, so it can wait for an idle slice after load. */
    if (typeof FingerprintJS !== 'undefined') {
        var startFingerprint = function () {
            (window.requestIdleCallback || function (f) { setTimeout(f, 1); })(function () {
                FingerprintJS.load()
                    .then(function (fp) { return fp.get(); })
                    .then(function (result) { window.__clientFingerprint = result.visitorId; })
                    .catch(function () {});
            });
        };
        if (document.readyState === 'complete') {
            startFingerprint();
        } else {
            window.addEventListener('load', startFingerprint, { once: true });
        }
    }

    /* The counter the other three tools use (getSmartWordCount in data_q.js).
       Japanese, Chinese and Korean write without spaces, so counting runs of
       non-space characters reported a whole essay as one word — and the server
       then refused it for being under the 30-word floor. Intl.Segmenter does the
       real work; TinySegmenter covers older Safari on Japanese, and the last
       resort divides CJK characters by 2.5, which is the ratio those scripts
       average out at. */
    /* Cut at a word boundary using the same counting as the footer counter, so
       the field lands exactly on the limit rather than one word over. */
    /* The detector had no modal of its own, so an upload problem was whispered
       into the counter line while the other three tools opened a dialog. It
       shares their markup now (partial.ds-limit-modal) and drives it here,
       since data_q.js — which owns showLimitModal — is not on this page. */
    function showDocModal(title, body, asHtml) {
        var modal = document.getElementById('limitModal');
        if (!modal) return showInputError(body);
        var titleEl = document.getElementById('limitModalTitle');
        var bodyEl = document.getElementById('limitModalBody');
        if (titleEl) titleEl.textContent = title;
        // only the sign-in notice passes markup, and it passes a link
        if (bodyEl) bodyEl[asHtml ? 'innerHTML' : 'textContent'] = body;
        modal.classList.add('modal-open');
        document.body.classList.add('modal-open');
        modal.querySelectorAll('[data-bs-dismiss], .modal-close').forEach(function (el) {
            el.addEventListener('click', function () {
                modal.classList.remove('modal-open');
                document.body.classList.remove('modal-open');
            }, { once: true });
        });
    }

    /* Signed in when the page loaded, signed out by the time it asked for a
       check. csrf.js will not repeat that request with the fresh token, because
       the fresh token belongs to a guest session: the check would run as a
       guest and never reach the account's history, and nobody would know. Say
       so instead — the text stays in the field, so it is one sign-in and one
       button away from being checked. */
    document.addEventListener('csrf:session-expired', function () {
        // Stopping the timer alone leaves the progress markup frozen in place.
        // Cleanup must happen even when a previous notice is still open.
        resetResult();
        if (document.getElementById('limitModal')?.classList.contains('modal-open')) return;
        showDocModal(
            t('det_js_signed_out_title', 'You have been signed out'),
            t('det_js_signed_out_body', 'Your session ended while this page was open, so nothing was saved to your account. Your text is still here — <a href=":url" target="_blank" rel="noopener">sign in again</a> and try once more.').replace(':url', window.cleverLoginUrl || '/login'),
            true
        );
    });

    function truncateToWords(text, limit) {
        var src = text || '';
        if (!limit || countWords(src) <= limit) return src;
        if (/[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uac00-\ud7af]/.test(src) && typeof Intl !== 'undefined' && 'Segmenter' in Intl) {
            var seg = new Intl.Segmenter(undefined, { granularity: 'word' }), seen = 0, end = 0;
            for (var s of seg.segment(src)) {
                if (!s.isWordLike) continue;
                seen++; end = s.index + s.segment.length;
                if (seen >= limit) break;
            }
            return src.slice(0, end).trimEnd();
        }
        var re = /\S+/g, m, seen2 = 0, end2 = 0;
        while ((m = re.exec(src)) !== null) {
            seen2++; end2 = m.index + m[0].length;
            if (seen2 >= limit) break;
        }
        return src.slice(0, end2).trimEnd();
    }

    function countWords(value) {
        var t = (value || '').trim();
        var base = t ? t.split(/\s+/u).filter(Boolean).length : 0;

        var hasHan = /\p{Script=Han}/u.test(t);
        var hasHira = /\p{Script=Hiragana}/u.test(t);
        var hasKata = /\p{Script=Katakana}/u.test(t);
        var hasHang = /\p{Script=Hangul}/u.test(t);
        if (!(hasHan || hasHira || hasKata || hasHang)) return base;

        if (typeof Intl !== 'undefined' && 'Segmenter' in Intl) {
            var locale = hasHira || hasKata ? 'ja' : (hasHang ? 'ko' : 'zh-Hans');
            var count = 0;
            for (var s of new Intl.Segmenter(locale, { granularity: 'word' }).segment(t)) {
                if (s.isWordLike) count++;
            }
            return Math.max(base, count);
        }

        if ((hasHira || hasKata) && typeof TinySegmenter !== 'undefined') {
            try {
                return Math.max(base, new TinySegmenter().segment(t).length);
            } catch (error) {}
        }

        var cjkChars = (t.match(/[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/gu) || []).length;
        return Math.max(base, Math.ceil(cjkChars / 2.5));
    }

    // Text copied out of the humanizer (or a document) can carry inflated blank
    // lines — the browser counts paragraph margins as line breaks when copying.
    // Keep at most one empty line between blocks.
    function normalizeText(value) {
        return String(value ?? '')
            .replace(/\r\n?/g, '\n')
            .replace(/\n{3,}/g, '\n\n');
    }

    /* Typing used to do all of the below on every keystroke: count the words in
       the whole field — a split of the entire text plus four unicode probes —
       and write the entire text into sessionStorage synchronously. With a long
       piece in the box that work IS the interaction on a phone, which is what
       put mobile INP at 347ms against Google's 200ms bar.

       Split by what the typist has to see immediately. The clear pill, the
       submit button and the dismissed error are one class toggle each and stay
       on the keystroke. The counter and the draft are deferred, so they land
       after the browser has painted the character rather than in front of it,
       and they coalesce while the keys keep coming.

       Only the input event defers. Everything a caller sets programmatically —
       a sample, a cleaned paste, an uploaded document, the restored draft —
       still goes through setInputState() and lands in one go, because those
       callers change the whole field at once and then read the counter. */
    var COUNTER_DELAY = 120;
    var DRAFT_DELAY = 600;
    var counterTimer = null;
    var draftTimer = null;

    function paintCounter() {
        counterTimer = null;
        var words = countWords(input.value);
        counter.textContent = t('det_js_words_counter', 'Words: :n / :max')
            .replace(':n', formatCount(words))
            .replace(':max', formatCount(maxWords));
        counter.style.color = words > maxWords ? 'var(--danger)' : '';
    }

    function saveDraft() {
        clearTimeout(draftTimer);
        draftTimer = null;
        try { sessionStorage.setItem('ai-detector-draft', input.value); } catch (error) {}
    }

    // What every path shares: three toggles, none of which reads the text.
    function paintInputChrome() {
        clearTimeout(inputErrorTimer);
        clear.classList.toggle('active', !!input.value.trim());
        syncSubmitState();
        inputError.hidden = true;
    }

    function setInputState() {
        paintInputChrome();
        clearTimeout(counterTimer);
        clearTimeout(draftTimer);
        paintCounter();
        saveDraft();
    }

    function onInputTyped() {
        paintInputChrome();
        if (counterTimer === null) counterTimer = setTimeout(paintCounter, COUNTER_DELAY);
        clearTimeout(draftTimer);
        draftTimer = setTimeout(saveDraft, DRAFT_DELAY);
    }

    function requestHeaders() {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrf ? csrf.content : '',
            'X-Client-Fingerprint': window.__clientFingerprint || ''
        };
    }

    /* Every call the detector makes goes through here, which is the one place
       worth teaching about an expired token: csrf.js repeats the request once
       with a fresh one, so a tab left open overnight checks text instead of
       announcing that the session is gone. */
    async function jsonRequest(url, options) {
        options.credentials = 'same-origin';
        var send = window.csrfFetch || window.fetch;
        var response = await send(url, options);
        var payload = {};
        try { payload = await response.json(); } catch (error) {}

        if (!response.ok) {
            var requestError = new Error(payload.message || payload.error || t('det_js_service_error', 'The detector service could not complete this request.'));
            requestError.status = response.status;
            requestError.payload = payload;
            throw requestError;
        }

        return payload;
    }

    /* The detector uses the same risk-based Turnstile flow as the humanizer:
       load the widget only after the server asks for it, then retry once. */
    var turnstileScriptPromise = null;

    function loadTurnstileScript() {
        if (window.turnstile) return Promise.resolve();
        if (!turnstileScriptPromise) {
            turnstileScriptPromise = new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
                script.async = true;
                script.onload = resolve;
                script.onerror = function () {
                    turnstileScriptPromise = null;
                    reject(new Error('Turnstile failed to load'));
                };
                document.head.appendChild(script);
            });
        }
        return turnstileScriptPromise;
    }

    /* Resolves with the token, null when the check could not be passed, or
       false when the visitor closed it. */
    async function obtainChallengeToken(sitekey) {
        try {
            await loadTurnstileScript();
        } catch (error) {
            return null;
        }

        return new Promise(function (resolve) {
            var overlay = document.createElement('div');
            overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:transparent;pointer-events:none;transition:background .2s;';
            var card = document.createElement('div');
            card.style.cssText = 'visibility:hidden;background:#fff;border-radius:12px;padding:24px;box-shadow:0 10px 40px rgba(0,0,0,.25);text-align:center;max-width:90vw;';
            var title = document.createElement('div');
            title.textContent = t('det_js_security_check', 'Quick security check');
            title.style.cssText = 'font-size:16px;font-weight:600;margin-bottom:12px;color:#0f172a;';
            var slot = document.createElement('div');
            var cancel = document.createElement('button');
            cancel.type = 'button';
            cancel.textContent = t('challenge_cancel', 'Cancel');
            cancel.style.cssText = 'margin-top:12px;padding:4px 8px;background:none;border:0;color:#475569;font:inherit;font-size:14px;text-decoration:underline;cursor:pointer;';
            card.appendChild(title);
            card.appendChild(slot);
            card.appendChild(cancel);
            overlay.appendChild(card);
            document.body.appendChild(overlay);

            var widgetId = null;
            var settled = false;
            var failures = 0;
            var hangTimer = null;
            var done = function (token) {
                if (settled) return;
                settled = true;
                window.clearTimeout(hangTimer);
                try {
                    if (widgetId !== null && window.turnstile) window.turnstile.remove(widgetId);
                } catch (error) {}
                overlay.remove();
                resolve(token);
            };
            var reveal = function () {
                overlay.style.background = 'rgba(15,23,42,.55)';
                overlay.style.pointerEvents = 'auto';
                card.style.visibility = 'visible';
            };
            var restart = function () {
                try {
                    window.turnstile.reset(widgetId);
                } catch (error) {
                    done(null);
                }
            };
            cancel.addEventListener('click', function () { done(false); });

            try {
                widgetId = window.turnstile.render(slot, {
                    sitekey: sitekey,
                    appearance: 'interaction-only',
                    retry: 'never',
                    'before-interactive-callback': function () {
                        // the visitor has the widget and Cancel now
                        window.clearTimeout(hangTimer);
                        reveal();
                    },
                    callback: function (token) { done(token); },
                    /* A failed attempt is not a failed check: right after the
                       checkbox click Cloudflare often fails the first round and
                       passes the next. Run it again, in view, a few times
                       (same as data_q.js). */
                    'error-callback': function (code) {
                        failures += 1;
                        console.warn('Turnstile error', code);
                        if (failures >= 3) {
                            done(null);
                            return true;
                        }
                        reveal();
                        window.setTimeout(function () {
                            if (!settled) restart();
                        }, 1000);
                        return true;
                    },
                    'expired-callback': restart
                });
            } catch (error) {
                done(null);
                return;
            }

            hangTimer = window.setTimeout(function () { done(null); }, 120000);
        });
    }

    // the server's own wording ("Please complete a quick verification")
    // reads as an order the visitor has just carried out
    function challengeFailure() {
        return new Error(t('challenge_failed_descr_detector', 'The security check did not go through. Your text is still here, please try again.'));
    }

    async function submitDetectorJob(text) {
        var body = { text: text, type_generation: 'detector' };

        try {
            return await jsonRequest(tool.dataset.submitUrl, {
                method: 'POST',
                headers: requestHeaders(),
                body: JSON.stringify(body)
            });
        } catch (error) {
            var challenge = error.payload;
            if (error.status !== 403 || !challenge || challenge.error_type !== 'challenge_required' || !challenge.sitekey) {
                throw error;
            }

            var token = await obtainChallengeToken(challenge.sitekey);
            if (!token) throw challengeFailure();
            body['cf-turnstile-response'] = token;

            try {
                return await jsonRequest(tool.dataset.submitUrl, {
                    method: 'POST',
                    headers: requestHeaders(),
                    body: JSON.stringify(body)
                });
            } catch (retryError) {
                if (retryError.status === 403 && retryError.payload && retryError.payload.error_type === 'challenge_required') {
                    throw challengeFailure();
                }
                throw retryError;
            }
        }
    }

    function endpoint(template, jobId) {
        return template.replace('__JOB_ID__', encodeURIComponent(jobId));
    }

    /* The word-floor refusal happens entirely in the browser, so without this
       ping nobody would ever learn how many visitors wanted to check shorter
       texts. Statistics only — the server keeps a count, not the text — and a
       failure here must never delay or break the modal the visitor is owed. */
    function reportShortText(words) {
        if (!tool.dataset.shortStatUrl) return;
        try {
            (window.csrfFetch || window.fetch)(tool.dataset.shortStatUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: requestHeaders(),
                body: JSON.stringify({ word_count: words }),
                keepalive: true
            }).catch(function () {});
        } catch (error) {}
    }

    function getJob(payload) {
        return payload.job || payload.data || payload;
    }

    function getJobId(job) {
        return job.uuid || job.job_uuid || job.job_id || job.id || null;
    }

    function getStatus(job) {
        return String(job.status || job.state || '').toLowerCase();
    }

    /* No text, no check — the same rule the paraphraser and the checker follow.
       Kept in one place so the busy state and the empty state cannot fight over
       the attribute. */
    function syncSubmitState() {
        submit.disabled = busy || !input.value.trim();
    }

    function setBusy(isBusy) {
        busy = isBusy;
        /* every way a check ends passes here; renderResult builds the real
           scored text right after, in the same task, so nothing is painted
           in between */
        if (!isBusy) dropPendingScoredText();
        syncSubmitState();
        submit.textContent = isBusy ? t('det_js_checking', 'Checking…') : t('det_btn_check', 'Check for AI');
        output.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    }

    var inputErrorTimer;

    /* The humanizer paints its counter and drops the notice after a couple of
       seconds; the detector left both on screen until the next keystroke, which
       read as two different kinds of complaint. */
    function showInputError(message) {
        inputError.textContent = message;
        inputError.hidden = false;
        counter.style.color = 'var(--warn)';
        input.focus();

        clearTimeout(inputErrorTimer);
        inputErrorTimer = setTimeout(function () {
            inputError.hidden = true;
            setInputState();
        }, 2000);
    }

    /* ------------------------------------------------------------------ loader
       The .progress-wrap component the humanizer uses (async.css), with the
       detector wording from the sample: one status line, big percent, a phase
       hint instead of an ETA, and Cancel. A check takes a couple of seconds, so
       the track is eased over ~2.6s and then creeps, never reaching 100% before
       the result actually lands. */
    var LOADER_DURATION = 2600;

    function loaderPhase(progress) {
        return progress < .55 ? t('det_js_loader_seconds', 'a few seconds left')
            : progress < .9 ? t('det_js_loader_almost', 'almost there…')
            : t('det_js_loader_scoring', 'scoring sentences…');
    }

    function startLoader() {
        stopLoader();

        output.className = 'detector-output';
        output.innerHTML = '<div class="progress-wrap">' +
            '<p class="pstatus" id="detectorLoadingText" aria-live="polite">' + t('det_js_loader_status', 'Checking your text for AI…') + '</p>' +
            '<div class="progress-container pbar" id="detectorProgressBar" role="progressbar" aria-label="' + t('det_js_progress_aria', 'AI check progress') + '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
                '<div class="progress-bar" id="detectorProgressFill"></div>' +
            '</div>' +
            '<div class="pmeta">' +
                '<span class="ppct" id="detectorPercent">0%</span>' +
                '<span class="peta" id="detectorEta">' + t('det_js_loader_seconds', 'a few seconds left') + '</span>' +
                '<button type="button" class="pcancel" id="detectorCancel">' + t('det_js_cancel', 'Cancel') + '</button>' +
            '</div>' +
        '</div>' +
        /* the grey stand-in for the verdict under the progress - the card,
           the summary, two signal chips, the Humanize card, and a block for
           the room left (designer's "Result without shift", Oct 2026); CSS
           shows it on stacked layouts only, while the check is going */
        '<div class="sk-stack" aria-hidden="true">' +
            '<div class="sk sk-score"></div><div class="sk sk-l"></div><div class="sk sk-l s"></div>' +
            '<div class="sk-chips"><div class="sk"></div><div class="sk"></div></div>' +
            '<div class="sk sk-cta"></div><div class="sk sk-fill"></div>' +
        '</div>';
        document.getElementById('detectorCancel').addEventListener('click', cancelJob);

        var fill = document.getElementById('detectorProgressFill');
        var bar = document.getElementById('detectorProgressBar');
        var pctEl = document.getElementById('detectorPercent');
        var etaEl = document.getElementById('detectorEta');
        var started = window.performance.now();
        var lastPct = -1;

        loaderTimer = window.setInterval(function () {
            var t = Math.min(1, (window.performance.now() - started) / LOADER_DURATION);
            // easeOutCubic, as in the sample; the tail creeps so a slow job still moves
            var value = (1 - Math.pow(1 - t, 3)) * 92;
            if (t === 1) value = Math.min(97, 92 + (window.performance.now() - started - LOADER_DURATION) / 1600);

            var pct = Math.round(value);
            fill.style.width = pct + '%';
            if (pct === lastPct) return;
            lastPct = pct;
            pctEl.textContent = pct + '%';
            bar.setAttribute('aria-valuenow', pct);
            etaEl.textContent = loaderPhase(t);
        }, 60);
    }

    function stopLoader() {
        if (loaderTimer) window.clearInterval(loaderTimer);
        loaderTimer = null;
    }

    /** Status line only — the track keeps running on its own timing. */
    function showProgress(job) {
        var status = getStatus(job || {});
        var line = document.getElementById('detectorLoadingText');
        if (!line) return;
        line.textContent = status === 'queued' || status === 'pending'
            ? t('det_js_queued', 'Your check is queued…')
            : t('det_js_loader_status', 'Checking your text for AI…');
    }

    function showError(message) {
        stopPolling();
        stopLoader();
        activeJobId = null;
        setBusy(false);
        if (resultNote) resultNote.hidden = true;
        output.className = 'detector-output';
        output.innerHTML = '';

        var box = document.createElement('div');
        box.className = 'detector-status-error';
        var title = document.createElement('strong');
        title.textContent = t('det_js_error_title', 'We could not finish this check');
        var detail = document.createElement('p');
        detail.textContent = message;
        box.append(title, detail);
        output.appendChild(box);
        /* a failed check lands in the same panel - bring it into view too,
           or the error would go unseen below the fold */
        scrollToFinishedResult(output.closest('.humanResult'));
    }

    /* partial/unsupported-language-modal: the dialog every tool shows, with
       its subscribe form. It records the language the detector found in the
       text as the subscription's needed language. Closing it puts the focus
       back in the text. */
    function showUnsupportedLanguage(job) {
        showError(t('det_js_lang_unsupported', 'This language is not supported yet.'));
        if (window.openUnsupportedLanguageModal) {
            window.openUnsupportedLanguageModal({ language: job.language, tool: 'detector', returnFocus: input });
        }
    }

    function stopPolling() {
        if (pollTimer) window.clearTimeout(pollTimer);
        pollTimer = null;
    }

    function normalizeSentence(sentence, index) {
        if (typeof sentence === 'string') {
            return { index: index, text: sentence, score: 50, scored: false, reasons: [], start: null, end: null };
        }

        var reasons = sentence.reasons || sentence.signals || sentence.explanations || [];
        if (typeof reasons === 'string') reasons = [reasons];
        var hasPercentScore = sentence.ai_probability_percent != null || sentence.ai_score != null;
        var sentScore = sentence.ai_probability_percent ?? sentence.ai_score ?? sentence.score ??
            sentence.ai_probability ?? sentence.probability;
        var rawScore = Number(sentScore ?? 50);
        if (!hasPercentScore && rawScore >= 0 && rawScore <= 1) rawScore *= 100;

        return {
            index: Number.isFinite(Number(sentence.index)) ? Number(sentence.index) : index,
            text: sentence.text || sentence.sentence || sentence.content || '',
            score: Math.max(0, Math.min(100, rawScore)),
            // false when the 50 above is only a stand-in for a missing score
            scored: sentScore != null && Number.isFinite(rawScore),
            reasons: normalizeStrings(reasons),
            start: sentence.start != null && Number.isFinite(Number(sentence.start)) ? Math.max(0, Number(sentence.start)) : null,
            end: sentence.end != null && Number.isFinite(Number(sentence.end)) ? Math.max(0, Number(sentence.end)) : null,
            wordCount: sentence.word_count != null && Number.isFinite(Number(sentence.word_count)) ? Math.max(0, Number(sentence.word_count)) : null,
            label: sentence.label || sentence.verdict || '',
            color: typeof sentence.color === 'string' ? sentence.color : ''
        };
    }

    function normalizeStrings(values) {
        if (typeof values === 'string') values = [values];
        if (!Array.isArray(values)) return [];

        var seen = Object.create(null);
        return values.map(function (value) {
            if (value && typeof value === 'object') {
                value = value.reason || value.label || value.description || value.message || '';
            }
            return typeof value === 'string' ? value.trim() : '';
        }).filter(function (value) {
            var key = value.toLocaleLowerCase();
            if (!value || seen[key]) return false;
            seen[key] = true;
            return true;
        });
    }

    /* The detector answers with one verdict sentence plus a handful of short
       pattern names, all in the same list. The sentence belongs above the
       chips, and a chip made out of it would link to an anchor the signals
       page does not have, so the two are told apart by shape here. */
    function isSignalLabel(value) {
        var text = value.trim();
        if (!text) return false;
        return !/[.!?]$/.test(text) && text.split(/\s+/).length < 7;
    }

    function splitExplanation(values) {
        var labels = [];
        var sentences = [];
        normalizeStrings(values).forEach(function (value) {
            (isSignalLabel(value) ? labels : sentences).push(value);
        });
        return { labels: labels, sentences: sentences };
    }

    /* The service picks its verdict sentence from a fixed catalogue and always
       writes it in English; page.blade.php ships that catalogue translated,
       keyed by the English original. An unknown sentence is shown as sent. */
    var explanationTranslations = (function () {
        var source = (typeof window !== 'undefined' && window.DETECTOR_EXPLANATIONS) || {};
        var map = Object.create(null);
        Object.keys(source).forEach(function (key) {
            if (typeof source[key] === 'string') map[explanationKey(key)] = source[key];
        });
        return map;
    })();

    function explanationKey(value) {
        return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
    }

    function translateExplanation(value) {
        var key = explanationKey(value);
        return key ? (explanationTranslations[key] || key) : '';
    }

    function normalizeResult(job) {
        var source = job.result || job.report || job.detection || job;
        var hasPercentScore = source.ai_score != null || source.ai_probability_percent != null;
        var rawScore = Number(
            source.ai_score ?? source.ai_probability_percent ??
            source.score ?? source.ai_probability ?? source.probability ?? 0
        );
        // Laravel's ai_score and *_percent fields are always percentages.
        // Only legacy generic score/probability fields may use a 0..1 fraction.
        if (!hasPercentScore && rawScore >= 0 && rawScore <= 1) rawScore *= 100;
        var score = Math.max(0, Math.min(100, Math.round(rawScore)));
        var confidence = confidenceText(source);

        var explanationList = Array.isArray(source.explanation) ? source.explanation : [];
        var explanation = source.explanation && typeof source.explanation === 'object' && !Array.isArray(source.explanation)
            ? source.explanation
            : {};
        var explained = splitExplanation(
            normalizeStrings(source.reasons || source.signals || source.explanations || [])
                .concat(normalizeStrings(explanation.signals || []))
                .concat(normalizeStrings(explanationList))
        );
        var reasons = explained.labels;
        var rawSentences = Array.isArray(source.highlights) && source.highlights.length
            ? source.highlights
            : (source.sentences || source.sentence_details || source.sentence_scores || source.segments || []);
        var sentences = Array.isArray(rawSentences) ? rawSentences.map(normalizeSentence) : [];
        var rawSentenceCount = Number(source.sentence_count ?? source.sentenceCount);
        var sentenceCount = Number.isFinite(rawSentenceCount) && rawSentenceCount >= 0
            ? Math.floor(rawSentenceCount)
            : sentences.length;

        return {
            score: score,
            verdict: source.verdict || source.label || verdictFor(score),
            confidence: confidence,
            reasons: reasons,
            explanation: {
                summary: translateExplanation(
                    typeof explanation.summary === 'string' && explanation.summary.trim()
                        ? explanation.summary
                        : explained.sentences[0]
                ),
                signals: reasons
            },
            sentences: sentences,
            sentenceCount: sentenceCount
        };
    }

    function confidenceText(source) {
        // Ignore responses cached while confidence was synthesized from the AI score.
        if (source.confidence_source === 'score') return '';
        var levels = {
            high: t('det_js_confidence_high', 'High'),
            medium: t('det_js_confidence_medium', 'Medium'),
            low: t('det_js_confidence_low', 'Low')
        };
        var level = String(source.confidence_level || '').trim().toLowerCase();
        if (Object.prototype.hasOwnProperty.call(levels, level)) return levels[level];
        if (typeof source.confidence_label === 'string' && source.confidence_label.trim()) {
            return source.confidence_label.trim();
        }
        // The public API has already normalized confidence to 0..100, including
        // values below 1%. Do not reinterpret those values as fractions.
        if ((typeof source.confidence === 'number' || typeof source.confidence === 'string')
            && String(source.confidence).trim() !== '') {
            var value = Number(source.confidence);
            if (Number.isFinite(value) && value >= 0 && value <= 100) return value + '%';
        }
        return '';
    }

    function verdictFor(score) {
        if (score >= 80) return t('det_js_verdict_ai', 'Likely AI-generated');
        if (score >= 60) return t('det_js_verdict_possibly', 'Possibly AI-generated');
        if (score >= 40) return t('det_js_verdict_mixed', 'Mixed signals');
        return t('det_js_verdict_human', 'Likely human-written');
    }

    // The API names the highlight color itself: green, yellow, orange or red.
    // One tint per color, in the design system's own hues.
    var SENTENCE_TINT = {
        human: 'hsla(152, 62%, 45%, .16)',
        mixed: 'hsla(45, 90%, 48%, .28)',
        likely: 'hsla(28, 88%, 48%, .22)',
        ai: 'hsla(8, 62%, 48%, .2)'
    };

    function sentenceTheme(sentence) {
        var color = String(sentence.color || '').toLowerCase();
        var label = String(sentence.label || '').toLowerCase();
        if (color === 'green') return 'human';
        if (color === 'yellow') return 'mixed';
        if (color === 'orange') return 'likely';
        if (color === 'red') return 'ai';
        if (label.indexOf('human') !== -1) return 'human';
        if (/mixed|uncertain/.test(label)) return 'mixed';
        if (/(^|_)ai($|_)|machine|generated/.test(label)) return 'ai';
        return scoreTheme(sentence.score);
    }

    function sentenceBackground(sentence) {
        return SENTENCE_TINT[sentenceTheme(sentence)];
    }

    function sentenceProbabilityText(sentence) {
        var theme = sentenceTheme(sentence);
        if (theme === 'human') {
            var humanScore = sentence.score <= 50 ? 100 - sentence.score : sentence.score;
            return t('det_js_human_probability', ':pct% human probability').replace(':pct', Math.round(humanScore));
        }
        if (theme === 'ai') {
            var aiScore = sentence.score >= 50 ? sentence.score : 100 - sentence.score;
            return t('det_js_ai_probability', ':pct% AI probability').replace(':pct', Math.round(aiScore));
        }
        return t('det_js_ai_probability', ':pct% AI probability').replace(':pct', Math.round(sentence.score));
    }

    // the dial is shared with the stored-result page — see detector-gauge.js
    var Gauge = window.DetectorGauge;

    function scoreTheme(score) {
        return Gauge.theme(score);
    }

    function reasonText(reason) {
        return typeof reason === 'string'
            ? reason
            : (reason.label || reason.reason || reason.description || '');
    }

    function chipClass(fallbackTheme) {
        if (fallbackTheme === 'human') return 'sc-human';
        if (fallbackTheme === 'mixed') return 'sc-mixed';
        if (fallbackTheme === 'likely') return 'sc-likely';
        return 'sc-ai';
    }

    /* Every signal name above is also an anchor on the signals page, which is
       English-only — so the chip carries the English slug and shows the
       translated name. page.blade.php turns the chip into a link and reads
       the slug from here rather than from the visible label. */
    function signalSlug(label) {
        return label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    function signalLabel(label) {
        var slug = signalSlug(label);
        return slug ? t('det_sig_' + slug.replace(/-/g, '_'), label) : label;
    }

    /* A phone stacks the chips one per line, so a long list of signals is the
       difference between the thumbs being on the first screen and being two
       scrolls down. Past this many, the tail collapses behind a "Show all"
       pill — the same shape the humanizer clamps its result with. */
    var VISIBLE_SIGNALS = 2;

    function chipList(reasons, fallbackTheme) {
        var chips = document.createElement('div');
        chips.className = 'chips';
        var shown = 0;
        reasons.forEach(function (reason) {
            var label = reasonText(reason);
            if (!label) return;
            var chip = document.createElement('span');
            chip.className = 'sig-chip ' + chipClass(fallbackTheme);
            chip.dataset.slug = signalSlug(label);
            chip.textContent = signalLabel(label);
            if (shown >= VISIBLE_SIGNALS) chip.classList.add('sig-chip-extra');
            chips.appendChild(chip);
            shown++;
        });

        if (shown > VISIBLE_SIGNALS) {
            var more = document.createElement('button');
            more.type = 'button';
            more.className = 'sig-more';
            more.textContent = t('det_js_show_all_signals', 'Show all · :num signals')
                .replace(':num', formatCount(shown));
            more.addEventListener('click', function () {
                // the list opens downwards: the first chips stay where they
                // were read. Scroll anchoring could slide the page instead,
                // so it is off for the one layout the unfolding takes
                var root = document.documentElement;
                var anchoring = root.style.overflowAnchor;
                root.style.overflowAnchor = 'none';
                chips.classList.add('chips-open');
                more.remove();
                void root.offsetHeight;
                root.style.overflowAnchor = anchoring;
            });
            chips.appendChild(more);
        }

        return chips;
    }

    /* A sentence is AI-like above 50% AI, as rounded for display; one at
       exactly 50% is not. 0% AI-like sentences at 0-49%, or 100% AI-like at
       50-100%: no sentence argues with the score, so there is no highlight for
       the verdict line to point at. These are cases of their own, not the
       service's 0-9% and 90-100% rows. No scored sentence at all (the service
       skipped the sentence analysis) means no highlight either. */
    function clearVerdict(report) {
        var scores = (report.sentences || [])
            .filter(function (sentence) { return sentence.scored; })
            .map(function (sentence) { return Math.round(sentence.score); });
        var human = report.score < 50;
        if (human && (!scores.length || Math.max.apply(null, scores) <= 50)) {
            return report.score < 40
                ? t('det_js_sum_only_human', 'The text is most probably human-written.')
                : t('det_js_sum_only_human_seems', 'The text seems human-written.');
        }
        if (!human && (!scores.length || Math.min.apply(null, scores) > 50)) {
            return report.score >= 80
                ? t('det_js_sum_only_ai', 'The text is most probably AI-generated.')
                : t('det_js_sum_only_ai_seems', 'The text seems AI-generated.');
        }
        return '';
    }

    /* The verdict line the detector itself wrote, in the page's language, unless
       clearVerdict() has a plainer one. The served line is missing only when
       the service skips sentence analysis and returns no explanation at all;
       then the page says as much from the report's own numbers — the score
       band and the share of AI-like sentences. */
    function summaryText(report, theme) {
        var clear = clearVerdict(report);
        if (clear) return clear;

        var served = report.explanation && report.explanation.summary;
        if (served) return served;

        var sentences = report.sentences || [];
        var flagged = 0;
        sentences.forEach(function (sentence) {
            var name = sentenceTheme(sentence);
            if (name === 'ai' || name === 'likely') flagged++;
        });
        var share = sentences.length ? flagged / sentences.length : 1;
        if (theme === 'ai') {
            return share >= .5
                ? t('det_js_sum_ai', 'Strong AI-like signals appear throughout the sentences and the overall writing structure.')
                : t('det_js_sum_ai_few', 'The complete text reads as strongly AI-like, even though many sentences look human on their own.');
        }
        if (theme === 'likely') {
            return share >= .5
                ? t('det_js_sum_likely', 'AI-like signals are common in sentences and reinforced by the overall structure.')
                : t('det_js_sum_likely_few', 'The complete text leans AI-like, even though many sentences look human on their own.');
        }
        if (theme === 'mixed') {
            return t('det_js_sum_mixed', 'About half the sentences look AI-like, while the complete text stays closer to human writing.');
        }
        return share >= .34
            ? t('det_js_sum_human_some', 'Many sentences look AI-like on their own, but the complete text strongly appears human.')
            : t('det_js_sum_human', 'The sentences and the complete text both read as human writing.');
    }

    // Verdict card from sample v2.1: the verdict and percentage have equal visual
    // weight, with the compact dial centered in the same row.
    function buildResultCard(report, theme) {
        var word = theme === 'ai' ? t('det_js_card_ai', 'AI')
            : theme === 'likely' ? t('det_js_card_likely_ai', 'Likely AI')
            : theme === 'human' ? t('det_js_card_human', 'Human') : t('det_js_card_unclear', 'Unclear');
        var shownPct = theme === 'human' ? 100 - report.score : report.score;
        var card = document.createElement('div');
        card.className = 'res-card rc-' + theme;
        /* Translated verdicts run far longer than the English ones -- "No
           concluyente" against "Unclear" -- and a word that long needs a
           smaller type scale and its own row for the dial. The stylesheet
           cannot measure the word, so the length is flagged here. */
        if (word.length > 9) card.classList.add('rc-longword');
        card.setAttribute('role', 'img');
        /* an Unclear verdict does not say by itself which side the number
           counts, so it names it: "42% AI" */
        var pctUnit = theme === 'mixed' ? t('det_js_pct_ai', '% AI') : '%';
        card.setAttribute('aria-label', t('det_js_verdict_aria', 'Verdict: :verdict, :pct')
            .replace(':verdict', word).replace(':pct', shownPct + pctUnit));

        var icon = document.createElement('span');
        icon.className = 'rc-ic';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = Gauge.emoji(theme);

        var main = document.createElement('div');
        main.className = 'rc-main';
        var wordEl = document.createElement('span');
        wordEl.className = 'rc-word';
        wordEl.textContent = word;
        main.appendChild(wordEl);
        var num = document.createElement('span');
        num.className = 'rc-num';
        num.innerHTML = '<span>0</span><small></small>';
        num.querySelector('small').textContent = pctUnit;

        card.append(icon, main, num);
        card.insertAdjacentHTML('beforeend', Gauge.miniHtml(report.score, theme, t('det_js_report_probability', 'AI probability: :pct%').replace(':pct', report.score)));

        return { card: card, shownPct: shownPct };
    }

    function scoredTextFoot(hasInteractiveSentences, coversWholeText) {
        var legend = document.createElement('div');
        legend.className = 'legend';
        legend.innerHTML = '<span class="lg-h"><i></i>' + t('det_js_legend_human', 'surely human') + '</span>'
            + '<span class="lg-m"><i></i>' + t('det_js_legend_mixed', 'mixed') + '</span>'
            + '<span class="lg-o"><i></i>' + t('det_js_legend_likely', 'likely AI') + '</span>'
            + '<span class="lg-a"><i></i>' + t('det_js_legend_ai', 'surely AI') + '</span>'
            + (hasInteractiveSentences ? '<span>' + t('det_js_legend_tap', '· tap a sentence for details') + '</span>' : '');

        var note = document.createElement('p');
        note.className = 'detect-note';
        note.textContent = coversWholeText
            ? t('det_js_note_full_range', 'The detector returned one highlighted range covering the full text.')
            : t('det_js_note_probability', 'Probability, not a verdict. Colors show per-sentence signals, not accusations.');
        return [legend, note];
    }

    function showScoredText(text, foot) {
        inputRender.append(text);
        inputRender.hidden = false;
        if (inputFoot) {
            inputFoot.append.apply(inputFoot, foot);
            inputFoot.hidden = false;
        } else {
            inputRender.append.apply(inputRender, foot);
        }
        input.hidden = true;
    }

    /* The text being checked takes its scored form on the start tap, plain
       until the verdict colours it. The scored box, its colour key and Copy
       Text are taller than the textarea; switched in when the verdict landed,
       seconds after the tap, they pushed the parked result panel down the
       phone screen and Chrome counted the move as a layout shift (field CLS
       0.6+ on /ai-detector, Oct 2026). On the tap it is part of the input. */
    var pendingScoredText = false;

    function showPendingScoredText(value) {
        if (!inputRender) return;
        inputRender.innerHTML = '';
        if (inputFoot) inputFoot.innerHTML = '';
        var text = document.createElement('div');
        text.className = 'detector-sentences';
        text.id = 'detectorSentences';
        text.textContent = value;
        showScoredText(text, scoredTextFoot(SENTENCE_DETAILS, false));
        if (copyText) copyText.hidden = false;
        pendingScoredText = true;
    }

    // a check that ends without a verdict hands the textarea back
    function dropPendingScoredText() {
        if (!pendingScoredText) return;
        pendingScoredText = false;
        inputRender.innerHTML = '';
        inputRender.hidden = true;
        if (inputFoot) {
            inputFoot.innerHTML = '';
            inputFoot.hidden = true;
        }
        input.hidden = false;
        if (copyText) copyText.hidden = true;
    }

    // The scored text lives in the input panel now, so the result panel keeps the
    // card and the signals while the sentences stay where the text was typed.
    function renderScoredText(report) {
        if (!inputRender) return;

        inputRender.innerHTML = '';
        if (inputFoot) {
            inputFoot.innerHTML = '';
            inputFoot.hidden = true;
        }
        if (!report.sentences.length) {
            inputRender.hidden = true;
            input.hidden = false;
            return;
        }

        var text = document.createElement('div');
        text.className = 'detector-sentences';
        text.id = 'detectorSentences';
        var sourceChars = Array.from(submittedText || input.value || '');
        var ranged = report.sentences.map(function (sentence, index) {
            return { sentence: sentence, index: index };
        }).filter(function (item) {
            return Number.isInteger(item.sentence.start) && Number.isInteger(item.sentence.end)
                && item.sentence.start >= 0 && item.sentence.end > item.sentence.start
                && item.sentence.end <= sourceChars.length;
        }).sort(function (a, b) {
            return a.sentence.start - b.sentence.start || a.sentence.end - b.sentence.end;
        });
        var hasInteractiveSentences = false;

        function sentenceSpan(sentence, index, content) {
            var state = sentenceTheme(sentence);
            /* the popover explains the color itself, so every colored
               sentence has details — green ones included */
            var hasDetails = SENTENCE_DETAILS;
            var span = document.createElement('span');
            span.className = 'detector-sentence sentence-' + state + (hasDetails ? ' has-details' : '');
            span.dataset.index = index;
            span.style.backgroundColor = sentenceBackground(sentence);
            span.textContent = content;
            span.title = sentenceProbabilityText(sentence) + (hasDetails ? t('det_js_tap_details', ' — tap for details') : '');

            if (hasDetails) {
                hasInteractiveSentences = true;
                span.tabIndex = 0;
                span.setAttribute('role', 'button');
                span.setAttribute('aria-haspopup', 'dialog');
                span.setAttribute('aria-expanded', 'false');
                span.addEventListener('click', showSentenceDetail);
                span.addEventListener('keydown', function (event) {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        showSentenceDetail.call(span, event);
                    }
                });
            }
            return span;
        }

        function appendSentence(parent, sentence, index, content) {
            // Newline characters stay as plain text nodes, so blank (including
            // whitespace-only) lines never inherit a highlight background.
            content.split(/(\r\n|\r|\n)/).forEach(function (part) {
                if (!part || /^(\r\n|\r|\n)$/.test(part) || !part.trim()) {
                    parent.appendChild(document.createTextNode(part));
                    return;
                }
                parent.appendChild(sentenceSpan(sentence, index, part));
            });
        }

        if (ranged.length) {
            var cursor = 0;
            ranged.forEach(function (item) {
                var sentence = item.sentence;
                if (sentence.start < cursor) return;
                if (sentence.start > cursor) {
                    text.appendChild(document.createTextNode(sourceChars.slice(cursor, sentence.start).join('')));
                }
                var content = sourceChars.slice(sentence.start, sentence.end).join('');
                sentence.text = sentence.text || content;
                appendSentence(text, sentence, item.index, content);
                cursor = sentence.end;
            });
            if (cursor < sourceChars.length) {
                text.appendChild(document.createTextNode(sourceChars.slice(cursor).join('')));
            }
        } else {
            report.sentences.forEach(function (sentence, index) {
                appendSentence(text, sentence, index, sentence.text + (index + 1 < report.sentences.length ? ' ' : ''));
            });
        }

        var coversWholeText = ranged.length === 1
            && ranged[0].sentence.start === 0
            && ranged[0].sentence.end >= sourceChars.length;
        showScoredText(text, scoredTextFoot(hasInteractiveSentences, coversWholeText));
    }

    /* The scored text is capped at one screen so a long report cannot stretch
       the card, and whatever height the report column has over it goes above
       the colour key (ai-detector.css). Both are right until the text is long
       enough to scroll: then the box is cut off with free space sitting right
       beneath it, which reads as a mistake. In that one case the text takes
       the space — the cap was there to stop the card growing, not to keep the
       box smaller than the room it already has. */
    var fitFrame = 0;
    var fitWatcher = null;

    /* The colour key is pinned to the bottom of this column by its auto top
       margin, so the distance from the top of the text box down to the key is
       exactly the room the text has. The inline height is cleared before
       measuring, or the number would be the one we set last time rather than
       the room that is actually there — which is how a report column that
       later shrank left the box too tall. */
    function applyScoredTextFit() {
        if (!inputRender || inputRender.hidden || !inputFoot || inputFoot.hidden) return;
        if (!matchMedia('(min-width: 901px)').matches) {
            inputRender.style.maxHeight = '';
            return;
        }
        if (inputRender.style.maxHeight) inputRender.style.maxHeight = '';
        var room = Math.round(
            inputFoot.getBoundingClientRect().top - inputRender.getBoundingClientRect().top
        );
        if (room <= 0) return;
        // scrolling text takes the room; text that fits keeps its own height,
        // and the spare space stays above the colour key
        var wanted = Math.min(room, inputRender.scrollHeight);
        if (Math.abs(wanted - inputRender.clientHeight) > 1) {
            inputRender.style.maxHeight = wanted + 'px';
        }
    }

    function fitScoredText() {
        if (fitFrame) return;   // one measurement per frame is plenty
        fitFrame = requestAnimationFrame(function () {
            fitFrame = 0;
            applyScoredTextFit();
        });
    }

    /* Measuring once is not enough: the report column keeps settling after the
       text lands — web fonts reflow the sentences, the banner appears, the
       signals wrap differently. Missing any of that left the box short with
       the room sitting beside it, which a window resize then "fixed" by hand.
       Watch instead of guess.

       The watched blocks are all content-sized (the verdict head, the signals,
       the banner, the colour key): none of them is stretched by the row, so
       re-fitting can never resize what triggered it. They are rebuilt on every
       report, hence the re-subscribe. */
    function watchScoredText() {
        if (typeof ResizeObserver !== 'function' || !inputRender) return;
        if (!fitWatcher) fitWatcher = new ResizeObserver(function () { applyScoredTextFit(); });
        fitWatcher.disconnect();
        ['.score-head', '.ai-reasons', '.result-note'].forEach(function (selector) {
            var node = tool && tool.querySelector(selector);
            if (node) fitWatcher.observe(node);
        });
        if (inputFoot) fitWatcher.observe(inputFoot);
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(function () { fitScoredText(); });
        }
    }

    function renderResult(job) {
        stopPolling();
        stopLoader();
        setBusy(false);
        currentReport = normalizeResult(job);
        tool.classList.add('has-result');
        /* second jump, when there is something to see: the phone re-aligns on
           the panel, a desktop shows the whole tool */
        scrollToFinishedResult(output.closest('.humanResult'));
        var report = currentReport;

        output.className = 'detector-output';
        output.innerHTML = '';

        var theme = scoreTheme(report.score);
        var head = document.createElement('div');
        head.className = 'score-head';
        var built = buildResultCard(report, theme);
        head.appendChild(built.card);
        if (report.confidence) {
            var confidence = document.createElement('div');
            confidence.className = 'detector-confidence';
            var confidenceLabel = document.createElement('strong');
            confidenceLabel.textContent = t('det_js_report_confidence', 'Confidence: :value').replace(':value', report.confidence);
            confidence.appendChild(confidenceLabel);
            head.appendChild(confidence);
        }
        output.appendChild(head);

        var summary = summaryText(report, theme);
        if (summary || report.reasons.length) {
            var reasons = document.createElement('div');
            reasons.className = 'ai-reasons';
            if (summary) {
                var explanationSummary = document.createElement('p');
                explanationSummary.className = 'detector-summary-copy';
                explanationSummary.textContent = summary;
                reasons.appendChild(explanationSummary);
            }
            if (report.reasons.length) reasons.appendChild(chipList(report.reasons, theme));
            output.appendChild(reasons);
        } else if (theme === 'human') {
            var humanNote = document.createElement('div');
            humanNote.className = 'human-note';
            humanNote.innerHTML = '<b>' + t('det_js_reads_human', 'Reads like human writing.') + '</b>';
            output.appendChild(humanNote);
        }
        /* The human side of the verdict says how the sentences read - the
           room the AI side spends on its signal chips (designer's "Result
           without shift", Oct 2026) */
        var humanSide = report.score < 50;
        if (humanSide && report.sentences.length) output.appendChild(sentenceMix(report.sentences));

        Gauge.animateCard(built.card, built.shownPct);

        renderScoredText(report);
        submit.textContent = t('det_js_edit', 'Edit');

        /* the card under the verdict: "Reads like AI" with the humanizer as
           the next step, or "Reads human" with the grammar checker */
        setNoteVariant(humanSide);
        if (resultNote) resultNote.hidden = false;
        if (sentenceCounter) sentenceCounter.textContent = t('det_js_sentences_counter', 'Sentences analyzed: :n').replace(':n', formatCount(report.sentenceCount));
        if (copy) copy.disabled = false;
        /* the checked text is read-only now; Copy Text next to Edit hands it
           back out (the cross-banner handoff lands people here without a copy) */
        if (copyText) copyText.hidden = false;
        // result-feedback.js (guests): reveal the sign-in strip
        // result-feedback.js: sign-in strip + thumbs; the job's public uuid
        // is the rating's address (ai_detector_jobs carries its own owner)
        window.dispatchEvent(new CustomEvent('upsell:result', {
            detail: { detectorJobId: activeJobId }
        }));
        output.setAttribute('aria-busy', 'false');
        /* Last, once the banner and the counter are in place: they are part of
           the report column, and the scored text is fitted to whatever height
           that column ends up with — and keeps being fitted as it settles. */
        watchScoredText();
        fitScoredText();
    }

    /* "How the N sentences read": a bar of the sentence colours and their
       counts, in the legend's wording */
    function sentenceMix(sentences) {
        var counts = { human: 0, mixed: 0, likely: 0, ai: 0 };
        sentences.forEach(function (sentence) { counts[sentenceTheme(sentence)]++; });
        var parts = [
            ['human', 'mx-h', t('det_js_legend_human', 'surely human')],
            ['mixed', 'mx-m', t('det_js_legend_mixed', 'mixed')],
            ['likely', 'mx-o', t('det_js_legend_likely', 'likely AI')],
            ['ai', 'mx-a', t('det_js_legend_ai', 'surely AI')]
        ];
        var box = document.createElement('div');
        box.className = 'sentence-mix';
        var heading = document.createElement('p');
        heading.className = 'mix-h';
        heading.textContent = t('det_js_mix_heading', 'How the :n sentences read').replace(':n', formatCount(sentences.length));
        var bar = document.createElement('div');
        bar.className = 'mix-bar';
        bar.setAttribute('aria-hidden', 'true');
        var legend = document.createElement('p');
        legend.className = 'mix-l';
        parts.forEach(function (part) {
            var n = counts[part[0]];
            if (n) {
                var seg = document.createElement('i');
                seg.className = part[1];
                seg.style.flex = String(n);
                bar.appendChild(seg);
            }
            // the orange band is listed only where it occurs: a human text
            // rarely has one, and three counts read easier than four
            if (!n && part[0] === 'likely') return;
            var item = document.createElement('span');
            var dot = document.createElement('i');
            dot.className = part[1];
            item.appendChild(dot);
            item.appendChild(document.createTextNode(formatCount(n) + ' ' + part[2]));
            legend.appendChild(item);
        });
        box.appendChild(heading);
        box.appendChild(bar);
        box.appendChild(legend);
        return box;
    }

    /* The card under the verdict has two faces on one markup: "Reads like
       AI" hands the text to the humanizer, "Reads human" to the grammar
       checker. The AI face is the page's own; the human one is written here. */
    var noteAiFace = resultNote ? {
        text: resultNote.querySelector('.rn-txt').innerHTML,
        cta: humanizeCta ? humanizeCta.firstChild.textContent : '',
        href: humanizeCta ? humanizeCta.getAttribute('href') : ''
    } : null;

    function setNoteVariant(humanSide) {
        if (!resultNote || !noteAiFace) return;
        var human = humanSide && resultNote.dataset.grammarUrl;
        resultNote.classList.toggle('rn-human', !!human);
        var text = resultNote.querySelector('.rn-txt');
        if (human) {
            text.textContent = '';
            var title = document.createElement('b');
            title.textContent = t('det_js_note_human_title', 'Reads human');
            var free = document.createElement('mark');
            free.className = 'rn-free';
            free.textContent = t('det_note_free', '100% free to use');
            text.appendChild(title);
            text.appendChild(document.createTextNode(' ' + t('det_js_note_human_question', 'Want the grammar checked too?') + ' '));
            text.appendChild(free);
        } else {
            text.innerHTML = noteAiFace.text;
        }
        if (!humanizeCta) return;
        humanizeCta.firstChild.textContent = human ? t('det_js_note_human_cta', 'Check grammar') + ' ' : noteAiFace.cta;
        humanizeCta.setAttribute('href', human ? resultNote.dataset.grammarUrl : noteAiFace.href);
    }

    function closeSentencePopover() {
        if (!inputRender) return;
        var open = inputRender.querySelector('.why-pop');
        if (open) open.remove();
        inputRender.querySelectorAll('.detector-sentence.active').forEach(function (span) {
            span.classList.remove('active');
            span.setAttribute('aria-expanded', 'false');
        });
    }

    // Why a sentence has its color, in the words of the legend under the text.
    function colorExplanation(state) {
        if (state === 'human') return t('det_js_color_human', 'Reads like human writing.');
        if (state === 'mixed') return t('det_js_color_mixed', 'Has both human and AI patterns.');
        if (state === 'likely') return t('det_js_color_likely', 'Has many AI patterns.');
        return t('det_js_color_ai', 'Has strong AI patterns.');
    }

    // Explanation for one sentence: a small popover anchored under it (sample v2).
    function showSentenceDetail(event) {
        var span = event.currentTarget;
        var sentence = currentReport && currentReport.sentences[Number(span.dataset.index)];
        if (!sentence || !inputRender) return;

        var wasActive = span.classList.contains('active');
        closeSentencePopover();
        if (wasActive) return;
        span.classList.add('active');
        span.setAttribute('aria-expanded', 'true');

        var state = sentenceTheme(sentence);
        var pop = document.createElement('div');
        pop.className = 'why-pop w-' + state;

        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'wp-x';
        close.setAttribute('aria-label', t('det_js_close', 'Close'));
        close.textContent = '\u00D7';
        close.addEventListener('click', function (e) { e.stopPropagation(); closeSentencePopover(); });
        pop.appendChild(close);

        var title = document.createElement('strong');
        title.className = 'wp-title';
        title.textContent = sentenceProbabilityText(sentence);
        pop.appendChild(title);

        var why = document.createElement('p');
        why.className = 'wp-text';
        why.textContent = colorExplanation(state);
        pop.appendChild(why);

        var box = inputRender.getBoundingClientRect();
        var rects = [].slice.call(span.getClientRects()).filter(function (r) { return r.width > 1 && r.height > 1; });
        var last = rects.length ? rects[rects.length - 1] : span.getBoundingClientRect();
        var isPointerClick = event.type === 'click' && Number.isFinite(event.clientX) && Number.isFinite(event.clientY);
        var anchorTop = isPointerClick ? event.clientY : last.bottom;
        var anchorLeft = isPointerClick ? event.clientX : last.left;
        var desiredTop = anchorTop - box.top + inputRender.scrollTop + 8;
        pop.style.top = desiredTop + 'px';
        pop.style.left = '6px';
        inputRender.appendChild(pop);
        var minTop = inputRender.scrollTop + 4;
        var maxTop = inputRender.scrollTop + inputRender.clientHeight - pop.offsetHeight - 4;
        if (desiredTop > maxTop) {
            var aboveTop = anchorTop - box.top + inputRender.scrollTop - pop.offsetHeight - 8;
            pop.style.top = Math.max(minTop, aboveTop) + 'px';
        }
        pop.style.left = Math.max(6, Math.min(
            anchorLeft - box.left + inputRender.scrollLeft,
            inputRender.clientWidth - pop.offsetWidth - 10
        )) + 'px';
    }

    /* Same helper as in data_q.js (this file stays dependency-free): on a
       stacked layout the result panel is below the input, so the check would
       run off-screen. The panel is brought into view twice - on the start
       button (to show the progress) and again when the verdict or the error
       lands. The double rAF waits out the reveal of the panel (has-run lifts
       its display:none) — a same-tick scroll measures a hidden panel and
       lands short, which read as "works only the second time". */
    function scrollToResultPanel(panel, toHead) {
        if (!panel || !matchMedia('(max-width: 900px)').matches) return;
        var align = function () {
            var behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
            /* The guest strip is pinned under the header on phones, so it
               covers the top of whatever the scroll parks there. Park the
               panel against the strip's measured bottom edge instead of
               guessing an offset (see the humanizer's copy in data_q.js). */
            var strip = document.getElementById('detectorSignInBar');
            var pinned = strip && !strip.hidden && getComputedStyle(strip).position === 'fixed';
            var clearance = pinned
                ? strip.getBoundingClientRect().bottom
                : (parseFloat(getComputedStyle(panel).scrollMarginTop) || 0);
            var top = panel.getBoundingClientRect().top + window.scrollY - clearance;
            /* ...but never past the bottom of the panel itself: while the
               check is going the panel is only a loader box, and parked
               under the header it left the rest of the screen to the page
               under the card, which the verdict's height then moved in view
               (field CLS, Oct 2026). The screen's bottom edge stops a hair
               under the panel's: the disclaimer and the page under the card
               start just below the fold and are not counted when they move
               further down. The panel head is still in view, lower. The
               verdict itself is read from its head: that call parks the head
               under the header, whatever the panel's height. */
            /* a phone panel has the height of the finished verdict from the
               tap on (async.css), so the head goes under the header on the
               tap and the verdict needs no scroll of its own - one move, not
               a dip and a climb (Oct 2026 review) */
            if (!toHead && !matchMedia('(max-width: 900px)').matches) {
                var panelBottom = panel.getBoundingClientRect().bottom + window.scrollY;
                top = Math.min(top, panelBottom - 2 - window.innerHeight);
            }
            // already there (the second pass): a smooth scroll restarted on
            // the spot was reported as a shift of the panel (data_q.js)
            if (Math.abs(Math.max(0, top) - window.scrollY) < 2) return;
            window.scrollTo({ top: Math.max(0, top), behavior: behavior });
        };
        requestAnimationFrame(function () { requestAnimationFrame(align); });
        /* the closing phone keyboard resizes the viewport mid-scroll and the
           first pass can land short — settle again once the resize is over,
           unless the user has taken over the scroll by then */
        var userTookOver = false;
        var cancel = function () { userTookOver = true; };
        addEventListener('touchstart', cancel, { once: true, passive: true });
        addEventListener('wheel', cancel, { once: true, passive: true });
        window.setTimeout(function () {
            removeEventListener('touchstart', cancel);
            removeEventListener('wheel', cancel);
            if (!userTookOver) align();
        }, 600);
    }

    /* When the check finishes, a phone re-aligns on the result panel and a
       desktop scrolls the whole tool block under the header instead: there
       the panel sits beside the input, and the banner below the verdict was
       ending up under the fold. */
    function scrollToFinishedResult(panel) {
        if (!panel) return;
        /* the height held through a re-check is let go with the verdict -
           unless a shorter one would pull the page under the card up into
           view, in which case the room stays (see the humanizer's
           settleResultPanel) */
        /* a stacked layout parked the head on the tap (scrollToResultPanel)
           and keeps the room it held: shrinking pulled the page under the
           card up into view (data_q.js settleResultPanel) */
        if (matchMedia('(max-width: 900px)').matches) return;
        if (panel.style.minHeight) {
            var held = panel.style.minHeight;
            panel.style.minHeight = '';
            if (panel.getBoundingClientRect().bottom < window.innerHeight) panel.style.minHeight = held;
        }
        var toolBlock = panel.closest('.tool');
        if (!toolBlock) return;
        /* the header is two floors tall now: measured, so the tool's own tab
           row stays in view under it (tester, Oct 2026) */
        var headerHeight = (document.getElementById('header') || {}).getBoundingClientRect
            ? document.getElementById('header').getBoundingClientRect().height : 60;
        var top = toolBlock.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
        window.scrollTo({
            top: Math.max(0, top),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
    }

    async function submitCheck(event) {
        event.preventDefault();
        if (busy) return;
        // Once a report is visible this control becomes Edit. Its only job is
        // to restore the textarea; the next explicit click starts a new check.
        if (inputRender && !inputRender.hidden) {
            exitResultMode();
            return;
        }

        var words = countWords(input.value);
        // the same modal and the same floor as the other three tools
        if (words < minWords) {
            reportShortText(words);
            return showDocModal(
                t('det_js_more_text_title', 'A little more text, please'),
                t('det_js_more_text_body', 'These tools need at least :min words to work with. Paste a paragraph and try again.').replace(':min', formatCount(minWords))
            );
        }
        if (words > maxWords) return showInputError(t('det_js_too_long', 'Shorten the text to :max words or fewer.').replace(':max', formatCount(maxWords)));

        submittedText = input.value.trim();
        var version = ++requestVersion;
        activeJobId = null;
        currentReport = null;
        if (copy) copy.disabled = true;
        if (resultNote) resultNote.hidden = true;
        /* A re-check on a stacked layout keeps the panel at the height of
           the verdict it replaces (measured before the loader empties it):
           the next verdict lands in the same room, and the panel's head is
           parked under the header right away - one scroll, not a dip to the
           loader box and a climb back (Oct 2026 review; the humanizer's
           showLoader does the same). Let go with the verdict. */
        var panel = output.closest('.humanResult');
        var heldHeight = (tool.classList.contains('has-run') && panel && matchMedia('(max-width: 900px)').matches)
            ? Math.round(panel.getBoundingClientRect().height) : 0;
        var recheck = heldHeight > 0;
        if (recheck) panel.style.minHeight = heldHeight + 'px';
        // mobile shows the result panel only after the first run
        tool.classList.add('has-run');
        // the guest strip takes its place on this tap, not when the verdict lands
        window.dispatchEvent(new CustomEvent('upsell:start'));
        setBusy(true);
        showPendingScoredText(submittedText);
        startLoader();
        /* first jump: the progress comes into view as the check starts -
           parked by its bottom edge on a first check, by its head on a re-check */
        scrollToResultPanel(panel, recheck);

        try {
            var payload = await submitDetectorJob(submittedText);
            if (version !== requestVersion) return;
            var job = getJob(payload);
            activeJobId = getJobId(job);

            if (getStatus(job) === 'completed' || job.result || job.report || job.detection) {
                renderResult(job);
                return;
            }
            if (!activeJobId) throw new Error(t('det_js_no_job_id', 'The detector did not return a job identifier.'));
            showProgress(job);
            schedulePoll(500);
        } catch (error) {
            if (version !== requestVersion) return;
            if (error.sessionExpired) return;
            showError(error.status === 404
                ? t('det_js_endpoint_missing', 'The detector endpoint is not available yet. Please try again after the service is enabled.')
                : error.message);
        }
    }

    function schedulePoll(delay) {
        stopPolling();
        pollTimer = window.setTimeout(pollJob, delay || 1200);
    }

    async function pollJob() {
        if (!activeJobId) return;
        var version = requestVersion;
        try {
            var payload = await jsonRequest(endpoint(tool.dataset.statusUrlTemplate, activeJobId), {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'X-Client-Fingerprint': window.__clientFingerprint || ''
                },
                credentials: 'same-origin'
            });
            if (version !== requestVersion) return;
            var job = getJob(payload);
            var status = getStatus(job);

            if (status === 'completed' || status === 'succeeded' || status === 'done') return renderResult(job);
            if (status === 'failed' || status === 'error') {
                if (job.error && job.error.code === 'unsupported_language') {
                    return showUnsupportedLanguage(job);
                }
                return showError(job.message || (job.error && job.error.message) || t('det_js_job_failed', 'The detector job failed.'));
            }
            if (status === 'cancelled' || status === 'canceled') return showError(t('det_js_cancelled', 'The check was cancelled.'));

            showProgress(job);
            schedulePoll(1200);
        } catch (error) {
            if (version !== requestVersion) return;
            if (error.sessionExpired) return;
            showError(error.message);
        }
    }

    async function cancelJob() {
        var version = ++requestVersion;
        var cancelledJobId = activeJobId;
        activeJobId = null;
        stopPolling();
        stopLoader();
        if (!cancelledJobId) {
            setBusy(false);
            showError(t('det_js_cancelled', 'The check was cancelled.'));
            return;
        }

        try {
            await jsonRequest(endpoint(tool.dataset.cancelUrlTemplate, cancelledJobId), {
                method: 'POST',
                headers: requestHeaders(),
                body: JSON.stringify({})
            });
            if (version !== requestVersion) return;
            showError(t('det_js_cancelled', 'The check was cancelled.'));
        } catch (error) {
            if (version !== requestVersion || error.sessionExpired) return;
            showError(error.message);
        }
    }

    function resetResult() {
        // Responses belonging to a cleared/restored/cancelled run cannot revive it.
        requestVersion++;
        stopPolling();
        stopLoader();
        activeJobId = null;
        currentReport = null;
        tool.classList.remove('has-result');
        setBusy(false);
        if (copy) copy.disabled = true;
        if (resultNote) resultNote.hidden = true;
        if (sentenceCounter) sentenceCounter.textContent = t('det_js_sentences_counter', 'Sentences analyzed: :n').replace(':n', '0');
        closeSentencePopover();
        if (inputRender) {
            inputRender.innerHTML = '';
            inputRender.hidden = true;
            inputRender.style.maxHeight = ''; // the fitted height belonged to that report
        }
        if (inputFoot) {
            inputFoot.innerHTML = '';
            inputFoot.hidden = true;
        }
        input.hidden = false;
        output.className = 'detector-output is-empty';
        output.innerHTML = '<div class="detector-empty"><span>' + t('det_empty_badge', 'AI') + '</span><p>' + t('det_js_empty_hint', 'Your score and sentence signals will appear here.') + '</p></div>';
        if (copyText) copyText.hidden = true;
        window.dispatchEvent(new CustomEvent('upsell:cleared'));
    }

    // Back to the editable field, keeping the text that was checked.
    function exitResultMode(focus) {
        if (!inputRender || inputRender.hidden) return;
        resetResult();
        if (focus !== false) input.focus();
    }

    function reportText() {
        if (!currentReport) return '';
        var report = currentReport;
        var lines = [
            t('det_js_report_title', 'Clever AI Detector — report'),
            t('det_js_report_probability', 'AI probability: :pct%').replace(':pct', report.score),
            t('det_js_report_verdict', 'Verdict: :verdict').replace(':verdict', report.verdict)
        ];
        if (report.confidence) {
            lines.push(t('det_js_report_confidence', 'Confidence: :value').replace(':value', report.confidence));
        }
        lines.push(t('det_js_sentences_counter', 'Sentences analyzed: :n').replace(':n', formatCount(report.sentenceCount)));
        var summary = summaryText(report, scoreTheme(report.score));
        if (summary) {
            lines.push('', t('det_js_report_summary', 'Summary: :text').replace(':text', summary));
        }
        if (report.reasons.length) {
            lines.push('', t('det_js_report_signals', 'Signals:'));
            report.reasons.forEach(function (reason) {
                var label = reasonText(reason);
                if (label) lines.push('- ' + signalLabel(label));
            });
        }
        if (report.sentences.length) {
            lines.push('', t('det_js_report_sentence_signals', 'Sentence signals:'));
            report.sentences.forEach(function (sentence) {
                lines.push('- [' + t('det_js_pct_ai_score', ':pct% AI').replace(':pct', Math.round(sentence.score)) + '] ' + sentence.text);
            });
        }
        lines.push('', t('det_js_report_note', 'Note: AI detection is probabilistic and should not be treated as proof.'));
        return lines.join('\n');
    }

    async function copyReport() {
        var text = reportText();
        if (!text) return;
        var copied = false;
        try {
            await navigator.clipboard.writeText(text);
            copied = true;
        } catch (error) {
            var helper = document.createElement('textarea');
            helper.value = text;
            helper.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
            document.body.appendChild(helper);
            helper.select();
            copied = document.execCommand('copy');
            helper.remove();
        }
        if (!copied) return;
        copy.textContent = t('copied', 'Copied');
        copy.classList.add('copied');
        window.setTimeout(function () {
            copy.textContent = t('det_btn_copy_report', 'Copy Report');
            copy.classList.remove('copied');
        }, 1600);
    }

    /* Copy Text (next to Edit once a check is on screen): the plain checked
       text, not the report — the visitor who arrived through the humanizer's
       cross-banner still needs the text itself. */
    async function copyCheckedText() {
        var text = (submittedText || input.value || '').trim();
        if (!text) return;
        var copied = false;
        try {
            await navigator.clipboard.writeText(text);
            copied = true;
        } catch (error) {
            var helper = document.createElement('textarea');
            helper.value = text;
            helper.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
            document.body.appendChild(helper);
            helper.select();
            copied = document.execCommand('copy');
            helper.remove();
        }
        if (!copied) return;
        /* "Copied" is shorter than "Copy Text" in every locale, and the footer
           is a wrapping flexbox: letting the pill shrink re-flowed the whole
           row on phones. The width is frozen for the swap instead. */
        copyText.style.minWidth = copyText.offsetWidth + 'px';
        copyText.textContent = t('copied', 'Copied');
        copyText.classList.add('copied');
        window.setTimeout(function () {
            copyText.textContent = t('det_btn_copy_text', 'Copy Text');
            copyText.classList.remove('copied');
            copyText.style.minWidth = '';
        }, 1600);
    }

    form.addEventListener('submit', submitCheck);

    /* Same rule as the upload: a pasted wall of text is cut to this tool's limit
       instead of being accepted and then refused at submit. Typing past the
       limit is left alone — only a paste is trimmed. */
    function enforcePastedLimit() {
        setTimeout(function () {
            var text = input.value || '';
            if (!maxWords || countWords(text) <= maxWords) return;
            input.value = truncateToWords(text, maxWords);
            setInputState();
            showDocModal(
                t('det_js_kept_first_title', 'Kept the first :max words').replace(':max', formatCount(maxWords)),
                t('det_js_pasted_too_long', 'The text you pasted runs longer than :max words, so the first :max are in the field. Nothing is lost — put the rest through in a second pass.').replace(/:max/g, formatCount(maxWords))
            );
        }, 0);
    }

    input.addEventListener('input', onInputTyped);
    /* A draft is only worth keeping if it survives leaving the page, and the
       deferred write may still be pending when that happens. */
    input.addEventListener('blur', saveDraft);
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') saveDraft();
    });
    // Safari does not always reach visibilitychange on the way out.
    window.addEventListener('pagehide', saveDraft);
    // Browser form/disabled-state restoration happens after deferred scripts.
    // A back-forward cache return can also bring an abandoned loader with it.
    window.addEventListener('pageshow', function (event) {
        if (event.persisted) resetResult();
        setInputState();
    });
    // a resized window changes how much room the scored text has
    window.addEventListener('resize', fitScoredText, { passive: true });
    input.addEventListener('paste', function (event) {
        var pasted = event.clipboardData && event.clipboardData.getData('text/plain');
        if (!pasted) return;
        var cleaned = normalizeText(pasted);
        if (cleaned === pasted) {         // nothing to collapse — let the browser paste
            enforcePastedLimit();
            return;
        }
        event.preventDefault();
        input.setRangeText(cleaned, input.selectionStart, input.selectionEnd, 'end');
        setInputState();
        enforcePastedLimit();
    });
    input.addEventListener('keydown', function (event) {
        if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') submitCheck(event);
    });
    clear.addEventListener('click', function () {
        input.value = '';
        setInputState();
        resetResult();
        tool.classList.remove('has-run');
        input.focus();
    });
    document.getElementById('detectorSample').addEventListener('click', function () {
        input.value = sample;
        setInputState();
        input.focus();
    });
    var pasteHint = document.getElementById('detectorPasteHint');
    var pasteHintTimer;

    function showPasteHint() {
        if (!pasteHint) return;
        var isMac = /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);
        pasteHint.textContent = t('paste_hint', 'Press :keys to paste your text').replace(':keys', isMac ? '⌘V' : 'Ctrl+V');
        pasteHint.hidden = false;
        clearTimeout(pasteHintTimer);
        pasteHintTimer = setTimeout(function () { pasteHint.hidden = true; }, 3000);
    }

    document.getElementById('detectorPaste').addEventListener('click', async function () {
        // Same race as the other three tools: Chromium keeps readText() pending
        // while its clipboard-read bubble is unanswered, so the fallback has to
        // be reachable on a timer rather than only on a rejection.
        if (navigator.clipboard && navigator.clipboard.readText) {
            var waitTimer;
            var read = navigator.clipboard.readText().then(function (value) { return value || ''; }, function () { return ''; });
            var text = await Promise.race([
                read,
                new Promise(function (resolve) { waitTimer = setTimeout(function () { resolve(null); }, 1200); })
            ]);
            clearTimeout(waitTimer);
            if (text && text.trim()) {
                input.value = text;
                setInputState();
                input.focus();
                enforcePastedLimit();
                return;
            }
            if (text === null) {
                read.then(function (late) {
                    if (!late.trim() || input.value.trim()) return;
                    input.value = late;
                    setInputState();
                    input.focus();
                    enforcePastedLimit();
                    clearTimeout(pasteHintTimer);
                    if (pasteHint) pasteHint.hidden = true;
                });
            }
        }
        input.focus();
        showPasteHint();
    });
    var uploadButton = document.getElementById('detectorUpload');
    var uploadSpinner = document.querySelector('#detectorForm .editor-actions .dropzone-spinner');

    uploadButton.addEventListener('click', function () {
        document.getElementById('detectorFile').click();
    });

    /* The locale-aware endpoint the other three tools post to: /de/parse-document
       under a locale prefix, /parse-document in English. */
    function parseDocumentUrl() {
        var first = window.location.pathname.split('/').filter(Boolean)[0];
        return /^[a-z]{2}(-[a-z]{2})?$/i.test(first || '') ? '/' + first + '/parse-document' : '/parse-document';
    }

    document.getElementById('detectorFile').addEventListener('change', async function () {
        var file = this.files && this.files[0];
        this.value = '';
        if (!file) return;

        if (file.size > 10 * 1024 * 1024) {
            return showDocModal(t('det_js_file_wont_open', 'That file will not open'), t('det_js_file_too_big', 'It is over 10 MB. Try a smaller one.'));
        }
        if (!/\.(pdf|docx?|txt|md)$/i.test(file.name)) {
            return showDocModal(t('det_js_file_wont_open', 'That file will not open'), t('det_js_file_unsupported', 'Upload a PDF, DOCX, TXT or MD file.'));
        }

        /* Even a .txt goes to the server. Reading it here trusted the file name:
           an archive renamed to .md was read as text, and megabytes of binary
           dropped into the field froze the page. /parse-document looks at what
           the file actually is and refuses anything that is not a document —
           which is why the other three tools never had this. */

        // A PDF or a DOCX is not text, and reading it raw put its binary into
        // the field. It goes to /parse-document, the same extractor the
        // humanizer, the paraphraser and the checker upload through.
        uploadSpinner?.classList.remove('hidden');
        uploadButton.setAttribute('disabled', 'disabled');
        try {
            var token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
            var body = new FormData();
            body.append('file', file);
            if (token) body.append('_token', token);
            var response = await fetch(parseDocumentUrl(), {
                method: 'POST',
                headers: token ? { 'X-CSRF-TOKEN': token } : {},
                body: body
            });
            var data = await response.json().catch(function () { return null; });
            if (!response.ok || !data || data.error) {
                return showDocModal(t('det_js_file_wont_open', 'That file will not open'), data?.message || t('det_js_file_unreadable', 'We could not read that file. Try another one.'));
            }
            // Nothing extracted is a success as far as the server is concerned,
            // so say it here rather than blanking the field in silence.
            if (!(data.text || '').trim()) {
                return showDocModal(t('det_js_file_no_text_title', 'Nothing to read in that file'), t('det_js_file_no_text', 'We could not find any text in it. A scan or an export made of images carries no text layer, so there is nothing to pull out — try a file whose text you can select.'));
            }
            // the field is a plain textarea, so the text form is the one to take
            // — through normalizeText, since a PDF comes back full of blank lines
            var extracted = normalizeText(data.text || '');
            // A long file is cut to this tool's own limit rather than refused,
            // the way the humanizer, the paraphraser and the checker cut theirs.
            if (countWords(extracted) > maxWords) {
                extracted = truncateToWords(extracted, maxWords);
                showDocModal(
                    t('det_js_kept_first_title', 'Kept the first :max words').replace(':max', formatCount(maxWords)),
                    t('det_js_file_too_long', 'That file runs longer than :max words, so the first :max are in the field. Nothing is lost — put the rest through in a second pass.').replace(/:max/g, formatCount(maxWords))
                );
            }
            input.value = extracted;
            setInputState();
            input.focus();
        } catch (_) {
            showDocModal(t('det_js_file_wont_open', 'That file will not open'), t('det_js_file_unreadable', 'We could not read that file. Try another one.'));
        } finally {
            uploadSpinner?.classList.add('hidden');
            uploadButton.removeAttribute('disabled');
        }
    });
    if (copy) copy.addEventListener('click', copyReport);
    if (copyText) copyText.addEventListener('click', copyCheckedText);

    // any way back to editing: the quick actions, "Remove text" or a click in the field
    document.querySelector('#detectorForm .editor-actions')?.addEventListener('click', function () {
        exitResultMode(false);
    });

    // Clicking whitespace only dismisses the explanation. Editing is explicit,
    // so a slightly missed click never makes all highlights disappear.
    if (inputRender) {
        inputRender.addEventListener('click', function (event) {
            if (event.target.closest('.detector-sentence') || event.target.closest('.why-pop')) return;
            closeSentencePopover();
        });
    }

    // the popover closes on an outside click or Escape
    document.addEventListener('click', function (event) {
        if (!inputRender || !inputRender.querySelector('.why-pop')) return;
        if (event.target.closest('.why-pop') || event.target.closest('.detector-sentence')) return;
        closeSentencePopover();
    });
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeSentencePopover();
    });

    // Result note CTA: put the text in the fragment before the anchor's normal
    // target=_blank navigation. The fragment is not sent to the server and does
    // not depend on sessionStorage being available or copied by iOS Safari.
    if (humanizeCta) {
        humanizeCta.addEventListener('click', function () {
            var text = submittedText || input.value.trim();
            if (!text) return;   // nothing to hand over — follow the link as usual

            if (window.ToolHandoff) {
                // the human face of the card points at the grammar checker
                var action = resultNote && resultNote.classList.contains('rn-human') ? 'grammar' : 'humanize';
                humanizeCta.href = window.ToolHandoff.makeUrl(humanizeCta.href, action, text);
                return;
            }

            // Backward-compatible fallback if the small helper failed to load.
            try {
                sessionStorage.setItem('humanizer-draft', text);
            } catch (error) {
                return;
            }
            humanizeCta.href += (humanizeCta.href.indexOf('?') === -1 ? '?' : '&') + 'humanize=1';
        });
    }

    // Read and immediately remove the fragment from the visible URL. Keep the
    // sessionStorage fallback for handoffs initiated by an older cached asset.
    var shouldCheck = (window.ToolHandoff && window.ToolHandoff.requested('check'))
        || /[?&]check=1(&|$)/.test(window.location.search);
    var handoff = window.ToolHandoff ? window.ToolHandoff.consume('check') : null;
    if (!handoff) {
        try {
            handoff = sessionStorage.getItem('ai-detector-handoff');
            if (handoff) sessionStorage.removeItem('ai-detector-handoff');
        } catch (error) {}
    }

    if (handoff) {
        input.value = normalizeText(handoff);
        setInputState();
        if (shouldCheck && !window.TERMS_ACCEPTANCE_REQUIRED) {
            // drop the flag so a reload doesn't spend another check
            window.history.replaceState(null, '', window.location.pathname + window.location.hash);
            tool.scrollIntoView({ block: 'start' });
            submitCheck({ preventDefault: function () {} });
        }
        return;
    }

    try {
        input.value = sessionStorage.getItem('ai-detector-draft') || input.value;
    } catch (error) {}
    setInputState();
}());
